<template>
    <b-row>
        <b-col cols="12" class="text-center">
            <h2>{{ $t("perfil_sga.titulo_entradas") }}</h2>
            <p class="subtitle">{{ $t("perfil_sga.subtitulo_entradas") }}</p>
        </b-col>
        <b-col>
            <div v-if="loading" style="height: 200px">
                <LoaderComponent />
            </div>
            <div v-else-if="!pedidos || pedidos.length === 0" class="text-center pt-4 pb-5">
                <div>
                    <b-icon icon="bag-x" class="mb-3" />
                    <h4>{{ $t("perfil_sga.sin_entradas") }}</h4>
                    <p>{{ $t("perfil_sga.mensaje_sin_entradas") }}</p>
                </div>
            </div>
            <div v-else class="row col-12 col-md-10 mx-auto px-0">
                <div
                    class="w-100"
                    v-for="pedido in pedidos"
                    :key="pedido.order_id"
                >
                    <b-card class="border-0 mb-4" style="box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);">
                        <b-card-header class="card-header p-0 d-flex align-items-center">
                            <b-button class="w-100 d-flex text-dark border-0 bg-transparent py-3 pl-3 pr-1" v-b-toggle="'pedido-' + pedido.order_id" @click="toggleCollapse(pedido.order_id)">
                                <div class="w-100 d-flex justify-content-between d-md-block">
                                    <div class="w-auto d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center pr-0 pr-lg-4">
                                        <div class="w-auto d-flex flex-column flex-md-row align-items-start align-items-md-center">
                                            <div class="mb-3 mb-md-0">
                                                <div class="d-flex mb-1 mb-md-2">
                                                    <p class="mb-0">{{ pedido.event.name }}</p>
                                                </div>
                                                <div class="d-flex mb-2 mb-md-0 font-weight-normal">
                                                    <p class="mb-0 mr-3">{{ $t("perfil_sga.pedido_numero") }}</p>
                                                    <p class="mb-0">{{ pedido.order_id }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="font-weight-normal mb-2 mb-md-0 d-flex align-items-center">
                                            <b-icon icon="calendar" class="mr-2" />
                                            <span class="mr-2">
                                                {{ $t("perfil_sga.fecha_de_compra") }}
                                            </span>
                                            <span>
                                                {{ formatDate(pedido.fecha_compra) }}
                                            </span>
                                        </div>
                                        <div class="font-weight-normal mb-0">
                                            <p class="mb-0">
                                                <b-icon icon="receipt" class="mr-2" />
                                                {{ pedido.entradas.length !== 1 ? $t("perfil_sga.entradas") : $t("perfil_sga.entrada") }} {{ pedido.entradas.length }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex align-items-start align-items-md-center justify-content-end" style="min-width: fit-content">
                                    <p class="mb-0 d-none d-md-block" style="font-size: 11px; font-weight: 400; min-width: 105px;">
                                        {{ openEntradas[pedido.order_id] ? $t("perfil_sga.ocultar_detalles") : $t("perfil_sga.ver_detalles") }}
                                    </p>
                                    <b-icon :icon="openEntradas[pedido.order_id] ? 'chevron-up' : 'chevron-down'" class="ml-0 ml-md-2" />
                                </div>
                            </b-button>
                        </b-card-header>

                        <b-collapse :id="'pedido-' + pedido.order_id">
                            <b-card-body class="card-header border-0 rounded-0 d-flex flex-column align-items-start" style="padding: 0 0 8px !important;">
                                <div class="p-3 w-100" v-for="(entrada) in pedido.entradas" :key="entrada.id">
                                    <!-- ENTRADA ANULADA -->
                                    <template v-if="pedido.is_anulado || entrada.is_anulado">
                                        <div class="d-flex align-items-center justify-content-between w-100">
                                            <div class="d-flex align-items-center">
                                                <div>
                                                    <div class="d-flex mb-1">
                                                        <p class="mb-0 mr-1 font-weight-bold">{{ entrada.user.name }}</p>
                                                        <p class="mb-0 font-weight-bold">
                                                            {{ entrada.user.surname }}
                                                        </p>
                                                    </div>
                                                    <p class="mb-0 small text-muted">
                                                        {{ $t("perfil_sga.anulado") }} — {{ entrada.user.dni ?? '' }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="text-right">
                                                <div class="mb-2 px-0 d-flex align-items-center">
                                                    <b-icon icon="currency-euro" class="mr-2" />
                                                    <strong class="mr-1">
                                                        {{ $t("perfil_sga.precio") }}:
                                                    </strong>
                                                    <span>
                                                        {{ entrada.precio.precio_total }}€
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- ENTRADA NORMAL -->
                                    <template v-else>
                                        <div class="d-flex align-items-center w-100 mb-3">
                                            <div class="d-flex align-items-center">
                                                <div>
                                                    <div class="d-flex mb-1">
                                                        <p class="mb-0 mr-1 font-weight-bold">{{ entrada.user.name }}</p>
                                                        <p class="mb-0 font-weight-bold">
                                                            {{ entrada.user.surname }}
                                                        </p>
                                                    </div>
                                                    <p class="mb-0 small text-muted">
                                                        <b-icon icon="card-list" class="mr-2" />
                                                        {{ entrada.user.dni }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-100 small d-flex flex-column flex-md-row py-2">
                                            <div class="col-md-6 d-flex flex-column p-0" v-if="entrada.asiento">
                                                <div class="mb-2 px-0 d-flex flex-row align-items-start align-items-md-center">
                                                    <div class="d-flex align-items-center">
                                                        <b-icon icon="grid" class="mr-2" />
                                                        <strong class="mr-2 mr-md-1">
                                                            {{ $t("perfil_sga.zona") }}:</strong>
                                                    </div>
                                                    <span>{{ entrada.asiento.zona }}</span>
                                                </div>
                                                <div class="mb-2 px-0 d-flex flex-row align-items-start align-items-md-center">
                                                    <div class="d-flex align-items-center">
                                                        <b-icon icon="grid-3x3" class="mr-2" />
                                                        <strong class="mr-2 mr-md-1">
                                                            {{ $t("perfil_sga.asiento") }}:</strong>
                                                    </div>
                                                    <span>
                                                        {{ $t("perfil_sga.fila") }}:
                                                        {{ entrada.asiento.fila }},
                                                        {{ $t("perfil_sga.asiento") }}:
                                                        {{ entrada.asiento.asiento }}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-md-6 d-flex flex-column p-0">
                                                <div class="mb-2 px-0 d-flex align-items-center">
                                                    <b-icon icon="currency-euro" class="mr-2" />
                                                    <strong class="mr-1">
                                                        {{ $t("perfil_sga.precio") }}:
                                                    </strong>
                                                    <span>
                                                        {{ entrada.precio.precio_total }}€
                                                    </span>
                                                </div>
                                                <div class="mb-2 px-0 d-flex align-items-center">
                                                    <i class="fas fa-qrcode mr-2"></i>
                                                    <strong class="mr-1">QR:</strong>
                                                    <span>
                                                        {{ entrada.qr_code }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="d-flex align-items-center flex-wrap mt-3">
                                            <div v-if="entrada.urls.sga_apple_wallet_url" class="mr-3 mb-2">
                                                <button class="btn-wallet" @click="openWallet(entrada.urls.sga_apple_wallet_url)">
                                                    <img
                                                        src="@/assets/icons/apple.svg"
                                                        alt="apple icon"
                                                        class="mr-1"
                                                        style="width: 16px; height: 16px;"
                                                    />
                                                    <span class="ml-1">Apple Wallet</span>
                                                </button>
                                            </div>
                                            <div v-if="entrada.urls.sga_google_wallet_url" class="mr-3 mb-2">
                                                <button class="btn-wallet" @click="openWallet(entrada.urls.sga_google_wallet_url)">
                                                    <b-icon icon="google" class="mr-1" style="width: 15px; height: 15px;" />
                                                    <span class="ml-1">Google Wallet</span>
                                                </button>
                                            </div>
                                            <div v-if="entrada.urls.sga_printable_ticket_url" class="mb-2">
                                                <button class="btn-wallet" @click="openPrintableTicket(entrada.urls.sga_printable_ticket_url)">
                                                    <b-icon icon="printer" class="mr-1" style="width: 15px; height: 15px;" />
                                                    <span class="ml-1">Imprimir</span>
                                                </button>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
                <div class="col-12 d-flex justify-content-center px-0">
                    <FrontPagination :current_page="meta.current_page" :last_page="meta.last_page" v-on:change_page="setPage" />
                </div>
            </div>
        </b-col>
    </b-row>
</template>

<script>
    import LoaderComponent from '@/components/preloader/LoaderComponent';
    import FrontPagination from '@/components/frontend/components/FrontPagination';

    export default {
        data() {
            return {
                pedidos: [],
                meta: {},
                loading: false,
                openEntradas: {},
                current_page: 1,
            };
        },
        mounted() {
            this.getPedidos();
        },
        methods: {
            getPedidos() {
                this.loading = true;
                const params = {
                    filters: {
                        page: this.current_page,
                    },
                };

                this.$store.dispatch(this.config.getVuexAlias('front.perfil.pedidos.sga'), params).then(res => {
                    this.pedidos = res.data.data;
                    this.meta = res.data.meta;
                })
                    .catch(() => {
                        console.error('Error al obtener las entradas');
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            toggleCollapse(id) {
                this.$set(this.openEntradas, id, !this.openEntradas[id]);
            },
            formatDate(dateString) {
                if (!dateString) return '';
                try {
                    const [datePart, timePart] = dateString.split(' ');
                    const [day, month, year] = datePart.split('-');
                    const date = new Date(year, month - 1, day);
                    return date.toLocaleDateString('es-ES', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                    });
                } catch (error) {
                    return dateString;
                }
            },
            openWallet(url) {
                if (url) {
                    window.open(url, '_blank');
                }
            },
            openPrintableTicket(url) {
                if (url) {
                    window.open(url, '_blank');
                }
            },
            setPage(page) {
                this.current_page = page;
            },
        },
        watch: {
            current_page() {
                this.getPedidos();
            },
        },
        components: {
            LoaderComponent,
            FrontPagination,
        },
    };
</script>

<style scoped>
.btn-wallet {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 4px 12px;
    background-color: #ffffff;
    color: #343a40;
    border: none;
    border-radius: 6px;
    font-size: 12px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    transition: all 0.25s ease-in-out;
    cursor: pointer;
    text-transform: uppercase;
}

.btn-wallet:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
    transform: translateY(-1px);
    scale: 1.05;
}

.card-body {
    padding: 0 !important;
}
</style>
    